import { apiRequest } from './api';
import { AdvClient, AdvClientRequest } from '../types/adv';

export const advClientService = {
  // Get all advertising clients
  getAllAdvClients: async (): Promise<AdvClient[]> => {
    return await apiRequest<AdvClient[]>('/adv_clients');
  },

  // Get advertising client by ID
  getAdvClientById: async (id: number): Promise<AdvClient> => {
    return await apiRequest<AdvClient>(`/adv_clients/${id}`);
  },

  // Create new advertising client
  createAdvClient: async (client: AdvClientRequest): Promise<AdvClient> => {
    return await apiRequest<AdvClient>('/adv_clients/create', {
      method: 'POST',
      body: JSON.stringify(client)
    });
  },

  // Update existing advertising client
  updateAdvClient: async (id: number, client: AdvClientRequest): Promise<AdvClient> => {
    return await apiRequest<AdvClient>(`/adv_clients/${id}`, {
      method: 'PUT',
      body: JSON.stringify(client)
    });
  },

  // Delete advertising client
  deleteAdvClient: async (id: number): Promise<void> => {
    return await apiRequest<void>(`/adv_clients/${id}`, {
      method: 'DELETE'
    });
  }
}; 